import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
}
export function Badge({
  children,
  icon
}: BadgeProps) {
  return <div className="inline-flex gap-1.5 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-blue-500/15 border border-blue-400/40 text-blue-400 md:text-base whitespace-nowrap font-[500] font-sans items-center justify-start text-[10px] pl-[10px]" data-id="element-249">
      {icon && <span className="text-blue-400" data-id="element-250">{icon}</span>}
      {children}
    </div>;
}